import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/shared/patterns/AppShell';
import { platformNav, PLATFORM_PORTAL_TITLE } from '@/domains/platform';

// Portal del Super Admin. Vive en /superadmin porque el RBAC clonado ocupa /platform; en la
// Fase 0 el RBAC se re-homologa bajo este portal y la ruta pasa a /platform.
export const Route = createFileRoute('/_backoffice/superadmin')({
    component: () => (
        <AppShell title={PLATFORM_PORTAL_TITLE} nav={platformNav}>
            <Outlet />
        </AppShell>
    ),
});
